module.exports = [{
      plugin: require('../../../packages/greenlight-core/gatsby-browser.js'),
      options: {"plugins":[],"pathPrefix":"your-hot-job","data":{"contentful":{"spaceId":"mlt4xrx1omik"}},"ga":{"id":["UA-97981691-23"],"config":{"custom_map":{"dimension47":"industry","dimension48":"skill","dimension49":"publishDate","dimension50":"contentType","dimension54":"contentId","dimension55":"videoId","dimension56":"userId"}}},"initialState":{},"showQuestionnaire":false,"consumablesForQuestionnaire":2},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["UA-97981691-23"],"gtagConfig":{"custom_map":{"dimension47":"industry","dimension48":"skill","dimension49":"publishDate","dimension50":"contentType","dimension54":"contentId","dimension55":"videoId","dimension56":"userId"}},"pluginConfig":{"delayOnRouteUpdate":250}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
